import { Component, OnInit  } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { KeycloakService } from 'keycloak-angular';
import { CadastroPromptService } from '../../services/cadastro-prompt/cadastro-prompt.service';
import { Router } from '@angular/router';
import { GetPromptService } from '../../services/get-prompts/get-prompts.service';
import { desprotegerTJC, protegerTermos, removerStopwords,} from '../../shared/text-utils';
import { AuthService } from '../../services/auth.service';
import { MessageNotificationService } from '../../services/message-notification.service';
import { VALIDATION_MESSAGES, SUCCESS_MESSAGES, ERROR_MESSAGES } from '../../constants/validation-messages';
import { handleHttpError } from '../../utils/error-handler.util';
import { sanitizeTag, addTagUnique, isValidTag } from '../../utils/tag-utils';
import { CategoriaPai } from '../../constants/categoria-pai';
import { PromptDto } from '../../models/prompt-dto.model';
import {
  categoriaFilhaDoPaiFinalidade,
  resolveIdCategoriaPaiFinalidade,
} from '../../utils/categoria-finalidade.util';

@Component({
  selector: 'cadastro-prompt',
  templateUrl: './cadastro-prompt.component.html',
  styleUrls: ['./cadastro-prompt.component.css'],
  standalone: false,
})


export class CadastroPromptComponent implements OnInit {
  cadastro: FormGroup;
  MAX_RESUMO: number = 500;
  MAX_PROMPT: number = 12000;
  selectedCategories: any[] = [];

  text: string | undefined;
  termoMsg: string =
    'Eu confirmo que sou o titular dos direitos autorais sobre o conteúdo que estou submetendo e concordo com cessão de direitos autorais para a plataforma de Prompt do Tribunal de Justiça do Estado do Pará para utilizar, reproduzir, modificar, adaptar e exibir este conteúdo.';
  // Agora, userId vem do Keycloak e é do tipo string.
  userId: string | null = null;
  tags: string[] = [];
  newTag: string = '';
  isChecked = false;
  termo = false;
  mostrarModal: boolean = false;
  msgAnonimo: boolean = false;
  promptPaiId: number | null = null;
  private modalResolver: ((value: boolean) => void) | null = null;
  categorias: any[] = [];
  filtrarCategorias: any[] = this.categorias;
  filtrarCategoriasProcess: any[] = this.categorias;
  filtrarCategoriasIns: any[] = this.categorias;
  filtrarCategoriasJus: any[] = this.categorias;
  filtrarCategoriasAreaDir: any[] = this.categorias;
  selecionarCategorias: any[] = [];
  selecionarCaracFinalidade: any[] = [];
  selecionarIdCategorias: number[] = [];
  dropdownCategoria: boolean = false;
  todasAsFinalidades: any[] = [];
  idPaiFinalidade: number | null = null;

  constructor(
    private fb: FormBuilder,
    private keycloakService: KeycloakService,
    private cadastroPromptService: CadastroPromptService,
    private getPromptService: GetPromptService,
    private router: Router,
    private authService: AuthService,
    private messageNotificationService: MessageNotificationService
  ) {
    this.cadastro = this.fb.group({
      titulo: [''],
      instrucoes: [''],
      resumo: [''],
      prompt: [''],
      tagsInput: [''],
      anonimo: [false],
      termo: [false],
      pesquisaCategoria: [''],
    });
  }


  ngOnInit() {
    const userData = this.authService.getUserData();
    if (userData) {
      this.userId = userData.usuario_id;
    }

    const duplicatedPromptId = localStorage.getItem('duplicatedPromptId');
    this.consultarCategorias(duplicatedPromptId);
  }

  consultarCategorias(duplicatedPromptId: string | null) {
  this.cadastroPromptService.categoriaPrompt().subscribe({
    next: (res) => {
      this.categorias = res.data;
      this.idPaiFinalidade = resolveIdCategoriaPaiFinalidade(this.categorias);

      const ordenarPorDescricao = (a: any, b: any) => {
        const descA = a.categoria_descricao || '';
        const descB = b.categoria_descricao || '';
        return descA.localeCompare(descB);
      };

      if (this.idPaiFinalidade === null) {
        this.messageNotificationService.showError(
          'Categoria pai "Finalidade" não encontrada na base. Não foi possível carregar as finalidades.'
        );
        this.todasAsFinalidades = [];
        this.filtrarCategorias = [];
        this.filtrarCategoriasCarFid(this.categorias);
        if (duplicatedPromptId) {
          localStorage.removeItem('duplicatedPromptId');
        }
        return;
      }

      this.todasAsFinalidades = this.categorias
        .filter(
          (x) =>
            categoriaFilhaDoPaiFinalidade(x, this.idPaiFinalidade) &&
            x.status == 'A'
        )
        .sort(ordenarPorDescricao);

      this.filtrarCategorias = [...this.todasAsFinalidades];

      this.filtrarCategoriasCarFid(this.categorias);

      if (duplicatedPromptId) {
        this.carregarDadosDuplicacao(Number(duplicatedPromptId));
        localStorage.removeItem('duplicatedPromptId');
      }
    },
    error: (err) => {
      console.error('Erro ao consultar categorias do prompt:', err);
      const errorMessage = handleHttpError(err);
      this.messageNotificationService.showError(
        ERROR_MESSAGES.CATEGORIES_LOAD_FAILED + ' ' + errorMessage
      );
    },
  });
}

filtrarCategoriasCarFid(categorias: any[]) {
  const ordenarPorDescricao = (a: any, b: any) => {
    const descA = a.categoria_descricao || '';
    const descB = b.categoria_descricao || '';
    return descA.localeCompare(descB);
  };

  this.filtrarCategoriasProcess = this.categorias
    .filter((x) => x.categoria_pai == CategoriaPai.TipoDeProcesso && x.status == "A")
    .sort(ordenarPorDescricao);

  this.filtrarCategoriasAreaDir = this.categorias
    .filter((x) => x.categoria_pai == CategoriaPai.AreaDeDireito && x.status == "A")
    .sort(ordenarPorDescricao);

  this.filtrarCategoriasJus = this.categorias
    .filter((x) => x.categoria_pai == CategoriaPai.Justica && x.status == "A")
    .sort(ordenarPorDescricao);

  this.filtrarCategoriasIns = this.categorias
    .filter((x) => x.categoria_pai == CategoriaPai.Instancia && x.status == "A")
    .sort(ordenarPorDescricao);
}

  qtdCaracteres(campo: string): number {
    const valor = this.cadastro.get(campo)?.value;
    return valor ? valor.length : 0;
  }

 onTagInput(event: KeyboardEvent): void {
  const input = event.target as HTMLInputElement;
  const isComma = event.key === ',';
  const isEnter = event.key === 'Enter';

  if (isComma || isEnter) {
    event.preventDefault();
    const rawTag = input.value.trim();
    if (rawTag) {
      const sanitizedTag = sanitizeTag(rawTag);
      if (/^_+$/.test(sanitizedTag)) {
        this.messageNotificationService.showError(
          VALIDATION_MESSAGES.INVALID_TAG,
          'Palavra-chave inválida'
        );
        return;
      }
      if (isValidTag(sanitizedTag)) {
        this.tags = addTagUnique(sanitizedTag, this.tags);
      } else {
        this.messageNotificationService.showError(
          VALIDATION_MESSAGES.INVALID_TAG_KEYWORD,
          'Palavra-chave inválida'
        );
        return;
      }
    }
    input.value = '';
  }
}

onPaste(event: ClipboardEvent) {
  const { clipboardData } = event;
  let temp = clipboardData?.getData('text');
  event.preventDefault();
  if (!temp) return;
  const partes = temp.split(',').map((p) => p.trim()).filter((p) => p);
  partes.forEach((parte) => {
    const sanitizedTag = sanitizeTag(parte);
    if (isValidTag(sanitizedTag)) {
      this.tags = addTagUnique(sanitizedTag, this.tags);
    }
  });
  (event.target as HTMLInputElement).value = '';
}

  removeTag(tag: string): void {
    this.tags = this.tags.filter((t) => t !== tag);
  }

  toggleCheckbox(value: boolean): void {
    this.isChecked = value;
  }

  toggleCheckboxTermo(value: boolean): void {
    this.termo = value;
  }

  carregarDadosDuplicacao(promptId: number) {
    this.getPromptService.getPromptById(promptId).subscribe({
      next: (res) => {
        const promptArray = res.data;
        if (!promptArray || promptArray.length === 0) {
          this.messageNotificationService.showError(
            ERROR_MESSAGES.NOT_FOUND,
            'Dados não encontrados'
          );
          return;
        }
        const prompt = promptArray[0];
        this.promptPaiId = promptId;
        this.preencherFormulario(prompt);
        this.termoMsg =
          'Este prompt é uma adaptação de um modelo original. Ao duplicar e modificar este prompt, eu concordo em ceder os direitos autorais da versão modificada à plataforma, permitindo seu uso, adaptação, modificação e reprodução livremente.';
      },
      error: (err) => {
        console.error('Erro ao carregar prompt para duplicação:', err);
        const errorMessage = handleHttpError(err);
        this.messageNotificationService.showError(
          'Não foi possível carregar o prompt para duplicação. ' + errorMessage
        );
      },
    });
  }

  async preencherFormulario(prompt: PromptDto) {
    if (!prompt) {
      console.error('Erro: Nenhum dado de prompt para preencher o formulário.');
      return;
    }
    if (prompt.prompt_anonimo == true) {
      const resposta = await this.exibirModalConfirmacao();
      if (!resposta) {
        prompt.prompt_anonimo = false;
      }
    }
    this.cadastro.patchValue({
      titulo: prompt.prompt_titulo,
      resumo: prompt.prompt_descricao,
      prompt: prompt.prompt_comando,
      anonimo: prompt.prompt_anonimo,
      instrucoes: prompt.prompt_instrucoes,
    });

    const categorias = prompt.prompt_categoria ?? [];
    this.selecionarCategorias = categorias.filter((cat) =>
      categoriaFilhaDoPaiFinalidade(cat, this.idPaiFinalidade)
    );
    this.selecionarCaracFinalidade = categorias.filter(
      (cat) => !categoriaFilhaDoPaiFinalidade(cat, this.idPaiFinalidade)
    );

    if (Array.isArray(prompt.prompt_tags)) {
      this.tags = prompt.prompt_tags.map((tag: any) => tag.tag_nome);
    } else {
      this.tags = [];
    }
  }

  exibirModalConfirmacao(): Promise<boolean> {
    this.mostrarModal = true;
    return new Promise<boolean>((resolve) => {
      this.modalResolver = resolve;
    });
  }

  responder(resposta: boolean): void {
    this.mostrarModal = false;
    if (this.modalResolver) {
      this.modalResolver(resposta);
      this.modalResolver = null;
    }
  }

  salvarPrompt() {
    if (this.userId === null) {
      this.messageNotificationService.showError(
        VALIDATION_MESSAGES.LOGIN_REQUIRED
      );
      return;
    }

    if (!this.validarCamposObrigatorios()) {
      return;
    }
    const promptComando = this.cadastro.get('prompt')?.value;
    const regexTagsHTML = /<\/?[^>]+(>|$_)/g;
    if (regexTagsHTML.test(promptComando)) {
      this.messageNotificationService.showError(
        VALIDATION_MESSAGES.HTML_NOT_ALLOWED,
        'Validação de conteúdo'
      );
      return;
    }

    this.selecionarIdCategorias = Array.from(
      new Set([
        ...this.selecionarCategorias.map(cat => cat.categoria_id),
        ...this.selecionarCaracFinalidade.map(cat => cat.categoria_id)
      ])
    );

    const promptData: any = {
      prompt_titulo: this.cadastro.get('titulo')?.value,
      prompt_descricao: this.cadastro.get('resumo')?.value,
      prompt_comando: promptComando,
      prompt_tags: this.tags,
      prompt_anonimo: this.cadastro.get('anonimo')?.value,
      prompt_instrucoes: this.cadastro.get('instrucoes')?.value,
      prompt_categoria: this.selecionarIdCategorias,
    };
    if (this.promptPaiId !== null) {
      promptData.prompt_pai = this.promptPaiId;
    }
    this.cadastroPromptService.cadastrarPrompt(promptData).subscribe({
      next: (res) => {
        this.messageNotificationService.showSuccess(SUCCESS_MESSAGES.PROMPT_SAVED);
        setTimeout(() => this.router.navigate(['/painel']), 400);
      },
      error: (err) => {
        console.error('Erro ao salvar o prompt:', err);
        const errorMessage = handleHttpError(err);
        this.messageNotificationService.showError(errorMessage);
      },
    });
  }

  validarCamposObrigatorios(): boolean {
    if (this.cadastro.get('titulo')?.value == "") {
      this.messageNotificationService.showError(
        VALIDATION_MESSAGES.TITLE_REQUIRED,
        'Campo obrigatório'
      );
      return false;
    }

    if (this.cadastro.get('resumo')?.value == "") {
      this.messageNotificationService.showError(
        VALIDATION_MESSAGES.SUMMARY_REQUIRED,
        'Campo obrigatório'
      );
      return false;
    }

    if (this.cadastro.get('prompt')?.value == "") {
      this.messageNotificationService.showError(
        VALIDATION_MESSAGES.PROMPT_REQUIRED,
        'Campo obrigatório'
      );
      return false;
    }

    if (this.selecionarCaracFinalidade.length == 0) {
      this.messageNotificationService.showError(
        VALIDATION_MESSAGES.CATEGORIES_REQUIRED,
        'Campo obrigatório'
      );
      return false;
    }

    if (this.selecionarCategorias.length == 0) {
      this.messageNotificationService.showError(
        VALIDATION_MESSAGES.FINALITY_REQUIRED,
        'Campo obrigatório'
      );
      return false;
    }

    if (this.termo === false) {
      this.messageNotificationService.showError(
        VALIDATION_MESSAGES.TERMS_REQUIRED,
        'Aceite os termos'
      );
      return false;
    }

    return true;
  }

  filtrarCategoria(): void {
    const termoBusca = this.cadastro
      .get('pesquisaCategoria')
      ?.value.toLowerCase();
    
    if (!termoBusca) {
      this.filtrarCategorias = [...this.todasAsFinalidades];
      return;
    }

    this.filtrarCategorias = this.todasAsFinalidades.filter((categoria) =>
      categoria.categoria_descricao.toLowerCase().includes(termoBusca)
    );
  }


  alterarSelecao(categoria: any): void {
    const index = this.selecionarCategorias.findIndex(
      (item) => item.categoria_id === categoria.categoria_id
    );

    if (index !== -1) {
      this.selecionarCategorias.splice(index, 1);
    } else {
      this.selecionarCategorias.push(categoria);
    }
  }

  alterarSelecaoCaractFinalidade(categoria: any): void {
    const index = this.selecionarCaracFinalidade.findIndex(
      (item) => item.categoria_id === categoria.categoria_id
    );

    if (index !== -1) {
      this.selecionarCaracFinalidade.splice(index, 1);
    } else {
      this.selecionarCaracFinalidade.push(categoria);
    }
  }

  selecionado(categoria: any): boolean {
    return this.selecionarCategorias.some(
      (item) => item.categoria_id === categoria.categoria_id
    );
  }

  selecionadoCaractFinalidade(categoria: any): boolean {
    return this.selecionarCaracFinalidade.some(
      (item) => item.categoria_id === categoria.categoria_id
    );
  }

  alterarDropdown(): void {
    this.dropdownCategoria = !this.dropdownCategoria;
    if (this.dropdownCategoria) {
      this.filtrarCategoria();
    }
  }

  get descricaoCategoriasSelecionadas(): string {
    return this.selecionarCategorias
      .map((cat) => cat.categoria_descricao)
      .join(', ');
  }
}
